// extracted by mini-css-extract-plugin
export var article = "style-module--article--eb54f";
export var articleContainer = "style-module--articleContainer--05acc";
export var category = "style-module--category--bc4cc";
export var content = "style-module--content--864ec";
export var date = "style-module--date--c3cb3";
export var description = "style-module--description--e8244";
export var details = "style-module--details--284c8";
export var image = "style-module--image--34f7a";
export var imageContainer = "style-module--imageContainer--48564";
export var label = "style-module--label--76021";
export var masked = "style-module--masked--65111";
export var order = "style-module--order--a9981";
export var saveContainer = "style-module--saveContainer--a9ad9";
export var side = "style-module--side--0ddce";
export var textContainer = "style-module--textContainer--2bd66";
export var title = "style-module--title--2bf9b";
export var voiceContainer = "style-module--voiceContainer--38e08";